document.addEventListener('DOMContentLoaded', function() {
  const botoes = document.querySelectorAll('.product-tab-button');
  const paineis = document.querySelectorAll('.product-tab-panel');
  
  botoes.forEach(botao => {
    botao.addEventListener('click', function() {
      const tabId = this.getAttribute('data-tab');
      
      // Remove active de todos
      botoes.forEach(b => b.classList.remove('active'));
      paineis.forEach(p => p.classList.remove('active'));
      
      // Adiciona active no clicado
      this.classList.add('active');
      document.getElementById('tab-' + tabId).classList.add('active');
    });
  });
});
